window.addEventListener('OpusCartChange', (event)=>{
    const data = event.detail;
    const sectionCustom = document.querySelector('#opus-price-ct-container');
    if(sectionCustom){
      sectionCustom.remove()
    }
    const textCustomCountry = Shopify.locale === "nl" ? "BESPAAR" : "SAVE";
    const textPriceCountry = Shopify.locale === "en" || Shopify.locale === "de"   ? "TOTAL" : "TOTAAL"
    const stringOpus = window.localStorage.getItem('opusCartV2');
    const ObjectPrice = JSON.parse(stringOpus);
  console.log("ObjectPrice: ", ObjectPrice);
    let discountCompare = 0;
    let ogPriceTotal = 0;
    const listItemDetail = data.items;
  console.log("listItemDetail: ", listItemDetail);
    for(const item of listItemDetail){
      const listKeys = Object.keys(ObjectPrice);
      if(listKeys.includes(`${item.id}`)){
        ogPrice = ObjectPrice[`${item.id}`]?.compareAtPrice || 0;
      
        if(ogPrice){
           console.log("discountCompare", ogPrice)
          const flPrice = item.final_price;
          const lastPrice = ogPrice - flPrice;
          ogPriceTotal += ogPrice*item.quantity
          discountCompare= discountCompare+ (lastPrice*item.quantity);
        }
      }
}
  
  const checkoutBtn = document.querySelector(".cd-checkout-section-container");
       checkoutBtn.insertAdjacentHTML(
            "beforebegin",
            `<div id="opus-price-ct-container">
              <div  style="width: 100%; display: flex; flex-direction: column; font-size: 1.0em; padding-top: 10px; ">
                <div style="width: 100%; display: flex; padding-top: 1px; justify-content: space-between; font-weight: bold; gap: 10px; margin: auto;">
                    <span style="flex-shrink: 0; align-items: center;">
                      ${textPriceCountry}
                    </span>
                    
                    <div style="display: flex; gap: 5px; justify-content: center; align-items: center; color: #000000;">
                      <span style="font-weight: 400; color: #333333; text-decoration: line-through;">${window.OpusConvertMoney(ogPriceTotal)}</span>
                      <span>${data.money}</span>
                      <span style="display: inline-block; background-color: #008060; color: #ffffff; font-size: 14px; padding: 3px 8px; border-radius: 10px; ">
                         Discount ${window.OpusConvertMoney(discountCompare)}
                      </span>
                    </div>
                  </div>
                </div>
                <div style="display: flex; justify-content: space-between; margin-top: 10px; color: #121212bf; font-weight: 600;">
                  <span>SHIPPING</span>
                  <span>FREE</span>
                </div>
            </div>
            
            
            `
        );
});

// ${discountCompare? `<div style="width: 100%; display: flex; flex-direction: column; font-size: 1.0em; padding-top: 10px; ">
//     <div style="width: 100%; display: flex; padding-top: 1px; justify-content: space-between; font-weight: bold; gap: 10px; margin: auto;">
//         <span style="flex-shrink: 0; align-items: center;">
//         <strong style="color: #000000;">${textCustomCountry}</strong>
//         </span>
        
//         <div style="display: flex; gap: 5px; justify-content: center; align-items: center; color: #008060; ">
//           <span>${window.OpusConvertMoney(discountCompare)}</span>
//         </div>
//     </div>
// </div>` : "" }

//</div>

